import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import {
  DEFAULT_ACTION_MODE,
  onToggleShowKeyboardActions,
  toggleModeEditor,
} from "../store/toolbar";

const useKeyboardActions = () => {
  const dispatch = useAppDispatch();
  const { editorMode } = useAppSelector(
    (state) => state.developer.edit.toolbar
  );

  useEffect(() => {
    const onKeyDown = (event: any) => {
      const isEscapeKeyPressed = event.key === "Escape";
      const isAltKeyPressed = event.altKey;

      const isInsertMode = editorMode.mode.includes("insert");

      const resetMode = isEscapeKeyPressed && isInsertMode;

      if (resetMode) {
        dispatch(toggleModeEditor(DEFAULT_ACTION_MODE));
        return;
      }

      if (isAltKeyPressed) {
        const key = event.key.toUpperCase();
        // To insert field
        key === "1" && dispatch(toggleModeEditor("insert-field"));
        // To insert text
        key === "2" && dispatch(toggleModeEditor("insert-text"));
        // To insert image
        key === "3" && dispatch(toggleModeEditor("insert-image"));
        // To insert layout
        key === "4" && dispatch(toggleModeEditor("insert-layout"));
        // To insert tables
        key === "5" && dispatch(toggleModeEditor("insert-table"));
        // To show actions
        key === "." && dispatch(onToggleShowKeyboardActions(true));
      }
    };

    window.addEventListener("keydown", onKeyDown);

    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [dispatch, editorMode.mode]);

  return null;
};

export default useKeyboardActions;
